import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import "containers/Account/Onboarding/Onboarding.css";
import CustomBanner from "components/General/Form/CustomBanner";
import CustomCheckbox from "components/General/Form/CustomCheckbox";
import { connect } from "react-redux";

class OnboardingGuardianInvatation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_family_account: false,
    };
  }

  onCheckboxChange = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  onNextClicked(event) {
    event.preventDefault();
    if (this.state.is_family_account) {
      this.props.history.push("/onboarding-add-child");
    } else {
      this.props.dispatch({ type: "LOGIN_SUCCESS" });
      this.props.history.push(`/`);
    }
  }

  render() {
    return (
      <div>
        <CustomBanner message="Invatation to Join a Family Account as a Guardian" />
        <div className="onboarding_content">
          <TextTheme
            message="You've been invited by [username] to join their family account as a guardian for the following individuals:"
            className="text_medium text_black"
          />
          <br />
          <ul>
            <li>
              <TextTheme message="Child1" className="text_small text_black" />
            </li>
            <li>
              <TextTheme message="Child2" className="text_small text_black" />
            </li>
          </ul>
          <TextTheme
            message="As a guardian of this family account, you will be able to:"
            className="text_medium text_black"
          />
          <br />

          <ul>
            <li>
              <TextTheme
                message="Add and manage accounts for children younger than 13 years old."
                className="text_small text_black"
              />
            </li>
            <li>
              <TextTheme
                message="Supervise the activity of children younger than 13 years old."
                className="text_small text_black"
              />
            </li>
          </ul>
          <br />

          <b>
            <TextTheme
              message="Do you want to join this family account as a guardian?"
              className="text_medium text_dark_blue"
            />
          </b>
          <br />

          <CustomCheckbox
            name="is_family_account"
            value="True"
            defaultChecked={this.state.is_family_account}
            handleChange={this.onCheckboxChange.bind(this)}
            text="Yes, I want to join this family account as a guardian."
          />
          <CustomCheckbox
            name="is_family_account"
            value="False"
            defaultChecked={this.state.is_family_account}
            handleChange={this.onCheckboxChange.bind(this)}
            text="No, I do not want to join this family account as a guardian."
          />

          <div className="onboarding_button_options">
            <RoundedButton
              title="&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;"
              buttonClassName="background_dark_orange"
              textThemeClassName="text_medium text_white"
              handleOnClick={this.onNextClicked.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(OnboardingGuardianInvatation);
